export const pageInfo = {
   pageName: 'Edit Landing',
   filter: false,
   periodContainer: true,
}

export const formData = {
   organizers: [
      {
         id: 1,
         name: 'fileOrganizers1',
         type: 'file',
         inputAccept: 'image/*',
         title: 'Upload logo organizers*',
      },
   ],
   sponsors: [
      {
         id: 1,
         name: 'fileSponsors1',
         type: 'file',
         inputAccept: 'image/*',
         title: 'Upload logo sponsors*',
      }
   ],
   partners: [
      {
         id: 1,
         name: 'filePartners1',
         type: 'file',
         inputAccept: 'image/*',
         title: 'Upload logo partners*',
      }
   ]
}
